// HalalBadge — quiet "Family-friendly · Alcohol-free" pill in the guest's language (room cards, room page, booking page).
// Pork is deliberately not mentioned: in Ulcinj that is simply the norm, so we keep it subtle.
import React from 'react';
import { Baby, WineOff } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const T = {
  en: ['Family-friendly', 'Alcohol-free', 'A calm, family hotel — no alcohol is served'],
  me: ['Za porodice', 'Bez alkohola', 'Miran porodični hotel — alkohol se ne služi'],
  sq: ['Për familje', 'Pa alkool', 'Hotel i qetë familjar — nuk shërbehet alkool'],
  de: ['Familienfreundlich', 'Alkoholfrei', 'Ruhiges Familienhotel — es wird kein Alkohol ausgeschenkt'],
  ru: ['Для семей', 'Без алкоголя', 'Спокойный семейный отель — алкоголь не подаётся'],
  pl: ['Dla rodzin', 'Bez alkoholu', 'Spokojny hotel rodzinny — nie podajemy alkoholu'],
  hu: ['Családbarát', 'Alkoholmentes', 'Nyugodt családi szálloda — alkoholt nem szolgálunk fel'],
};
const ICONS = [Baby, WineOff];
const tone = (dark) => (dark ? 'border-white/15 bg-white/5 text-white/80' : 'border-slate-200 bg-slate-50 text-slate-600');

// variant: "card" (one small pill on room cards) | "panel" (two chips + a quiet line on the room page)
export const HalalBadge = ({ variant = 'card', dark = false, className = '' }) => {
  const { lang } = useLanguage();
  const t = T[lang] || T.en;
  if (variant === 'card') {
    return (
      <div className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-medium ${tone(dark)} ${className}`} title={t[2]} data-testid="halal-badge">
        <Baby size={12} className="flex-shrink-0" />
        <span>{t[0]} · {t[1]}</span>
      </div>
    );
  }
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="halal-badge-panel">
      {t.slice(0, 2).map((label, i) => {
        const Icon = ICONS[i];
        return (
          <span key={label} className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium ${tone(dark)}`} data-testid={`halal-chip-${i}`}>
            <Icon size={13} />{label}
          </span>
        );
      })}
      <span className={`text-xs ${dark ? 'text-white/50' : 'text-slate-400'}`}>{t[2]}</span>
    </div>
  );
};
